import styled from '@emotion/styled';
const Card = styled.article `
  border: ${({ theme }) => theme.borderWidth[25]} solid ${({ theme }) => theme.color.border.base};
  border-radius: ${({ theme }) => theme.borderRadius[100]};
  padding: ${({ theme }) => theme.spacing[600]};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    cursor: pointer;
  }
`;
export { Card };
//# sourceMappingURL=styled.js.map